export const MessageType = {
    TYPE_TEXT: 1,
    TYPE_IMAGE: 2
};

export const WhichMessage = Object.freeze({
    MESSAGE_DATA: 1,
    BROADCAST_NEW_CHAT_SESSION: 2,
    BROADCAST_CHAT_DESTINATION_JOINED: 3,
    BROADCAST_CHAT_DESTINATION_UPDATED: 4,
    BROADCAST_CHAT_CUSTOMER_UPDATE: 5,
    BROADCAST_CHAT_ERROR: 6,
    BROADCAST_CHAT_SUCCESS: 7,
    BROADCAST_CHAT_CLOSED: 99,
});

export const Direction = {
    LEFT: "left",
    RIGHT: "right"
};

export const PayLoadType = {
    AS_NOTIFICATION: 1,
    AS_CHAT: 2,
    SEND_MESSAGE_TO_OTHER: 4,
};

export const Log_Allow = {
    DEBUG_ENABLED: true,
};

export const ChatStatus = {
    END_CHAT: 1,
    NEW_RECEIVE_CHAT: 2,
    RUNNING_CHAT: 3,
    STOP_BY_CUSTOMER: 4,
}

export const SOURCE = "source"
export const DESTINATION = "destination"
export const WS_TOKEN = "wsApiToken"
export const WS_PARENT_ID = "wsSnpParentToken"
export const WS_ADMIN_TOKEN = "wsAdminToken"


export const HTTP_SUCCESS = 200;

export const HTTP_UNAUTHORIZED = 401;
export const HTTP_NO_DATA = 402;
export const CHATKEYNOTREGISTERED = 410;
export const CHATSOCKETERROR = 499;
export const UNFORTUNATE_ERROR = 500;


export const CHAT_HTTPS_PROTOCOL = "https://";
export const CHAT_WSS_PROTOCOL = "wss://";
export const CHAT_SUB_DOMAIN = "chat.";
export const CHAT_DOMAIN_NAME = "snpnextgen.com";

export const CHAT_BASE_URL = `${CHAT_HTTPS_PROTOCOL}${CHAT_SUB_DOMAIN}${CHAT_DOMAIN_NAME}/api/`;
export const CHAT_SOCKET_BASE_URL = `${CHAT_WSS_PROTOCOL}${CHAT_SUB_DOMAIN}${CHAT_DOMAIN_NAME}/api/`;
export const CHAT_IMAGE_URL = `${CHAT_BASE_URL}files/`;

export const CHAT_SOCKET_URL = "snp-socket";
export const CHAT_SOCKET_ADMIN_URL = "snp-admin-socket";


export const InternalAddRemoveChannel = {
    Receive_Chat_Add: 1,
    Receive_Chat_Remove: 2,
    Receive_Chat_Full: 3,
    Receive_Chat_Empty: 4,
    Running_Chat_Add: 5,
    Running_Chat_Remove: 6,
    Running_Chat_Full: 7,
    Running_Chat_Empty: 8,
    Pending_Chat_Add: 9,
    Pending_Chat_Remove: 10,
    Pending_Chat_Full: 11,
    Pending_Chat_Empty: 12,
    Running_Recive_Chat_Replace: 13,
};

export const ToneType = {
    No_Sound: -1,
    New_Chat_Receive: 0,
    New_Message_Receive: 1,
    Error: 2,
};
